import React from 'react';
import { Card } from '../ui/Card';
import { LineChart } from '../analytics/charts/LineChart';
import { PieChart } from '../analytics/charts/PieChart';
import { useStore } from '../../store/useStore';
import { Department } from '../../types';

export const SystemMetrics: React.FC = () => {
  const messages = useStore((state) => state.messages);
  const tasks = useStore((state) => state.tasks);

  // Sample data for demonstration
  const communicationTrends = [
    { date: 'Mon', value: 45 },
    { date: 'Tue', value: 52 },
    { date: 'Wed', value: 49 },
    { date: 'Thu', value: 63 },
    { date: 'Fri', value: 58 },
    { date: 'Sat', value: 48 },
    { date: 'Sun', value: 54 },
  ];

  const departmentEngagement = [
    { label: 'Inventory', value: 35, color: 'bg-blue-500' },
    { label: 'Logistics', value: 25, color: 'bg-emerald-500' },
    { label: 'Finance', value: 20, color: 'bg-purple-500' },
    { label: 'Sales', value: 15, color: 'bg-amber-500' },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <LineChart
          title="Communication Trends"
          data={communicationTrends}
          color="bg-blue-500"
        />
        <PieChart
          title="Department Engagement"
          data={departmentEngagement}
        />
      </div>

      <Card className="p-6">
        <h2 className="text-lg font-semibold mb-4">System Health</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg">
            <h3 className="font-medium text-blue-700 mb-2">Message Delivery</h3>
            <p className="text-sm text-blue-600">99.9% success rate</p>
          </div>
          <div className="p-4 bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-lg">
            <h3 className="font-medium text-emerald-700 mb-2">System Uptime</h3>
            <p className="text-sm text-emerald-600">100% in last 30 days</p>
          </div>
          <div className="p-4 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg">
            <h3 className="font-medium text-purple-700 mb-2">Response Time</h3>
            <p className="text-sm text-purple-600">Average 0.5s</p>
          </div>
        </div>
      </Card>
    </div>
  );
};